module.exports = __webpack_public_path__ + "assets/img/dzh-10.5ca472fc.jpg";